<template>
    <frm-modal-component ref="modal" @save="save">
        <template #header>
            {{ $t("calendar.appointment.note") }}
        </template>

        <form ref="form" @submit.prevent="save">
            <frm-input-note-textarea
                v-model="noteLocal"
                :current-employee="currentEmployee"
                textarea-class="form-textarea--tall"
                autofocus
            />

            <template v-if="selectedEmployeeIds.length">
                <div class="form-checkbox">
                    <input
                        id="send-message-to-employees"
                        v-model="sendMessageToEmployees"
                        name="send-message-to-employees"
                        class="form-checkbox__input"
                        type="checkbox"
                    >
                    <label
                        for="send-message-to-employees"
                        class="form-checkbox__label"
                    >
                        {{ $t("calendar.notes.send_message_to", { employees: employeeNames }) }}
                    </label>
                </div>

                <frm-input-text
                    v-if="sendMessageToEmployees"
                    v-model="sendMessageToEmployeesSubject"
                    required
                    name="send-message-to-employees-subject"
                    :placeholder="$t('dashboard.messages.fields.subject')"
                />
            </template>
        </form>
    </frm-modal-component>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        note: {
            type: String,
            default: '',
        },
        currentEmployee: {
            type: String,
            required: true,
        },
        selectedEmployeeIds: {
            type: Array,
            default: () => [],
        },
    },

    computed: {
        employeeNames() {
            return this.allEmployees
                .filter(employee => this.selectedEmployeeIds.includes(employee.value))
                .map(employee => employee.label)
                .join(', ');
        },
    },

    data() {
        return {
            noteLocal: this.note,
            sendMessageToEmployees: false,
            sendMessageToEmployeesSubject: '',
            allEmployees: [],
        };
    },

    async mounted() {
        this.allEmployees = (await axios.get('/masterfiles/employees/smart_select')).data.data;
    },

    methods: {
        save() {
            if (!this.$refs.form.reportValidity()) {
                return;
            }

            this.$emit('set-note', {
                note: this.noteLocal,
                sendMessageToEmployees: this.sendMessageToEmployees,
                sendMessageToEmployeesSubject: this.sendMessageToEmployeesSubject,
            });
            this.$refs.modal.closeModal();
        },
    },
};
</script>
